import React, { FunctionComponent, ReactElement, useState } from 'react';

import {
  collapseActionButtonHeight,
  sidebarMenuComputedHeight,
} from '../../../styles/variables/sizes';
import { getRoutes } from '../../../utils/routes/routes.util';
import MenuList from '../MenuList/MenuList';
import MenuStateButton from '../MenuStateButton/MenuStateButton';
import Paper from '../Paper/Paper';
import SidebarMenuItem from '../SidebarMenuItem/SidebarMenuItem';
import { BaseSidebarMenuProps } from './models/sidebar-menu-props.model';

const SidebarMenu: FunctionComponent<BaseSidebarMenuProps> = (
  props: React.PropsWithChildren<BaseSidebarMenuProps>
): ReactElement => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const routes = getRoutes()[0].children;
  const handleMenuState = (): void => {
    setIsOpen(prevState => !prevState);
    props.propagateStateChange(isOpen);
  };

  return (
    <Paper
      sx={{
        height: `calc(100vh - ${sidebarMenuComputedHeight})`,
        position: 'fixed',
        zIndex: 10,
        top: sidebarMenuComputedHeight,
        left: 0,
        bottom: 0,
        backgroundColor: theme =>
          theme.palette.appWhite.sideBarMenuContainerBgColor,
        borderRadius: '0',
        boxShadow: 'unset',
      }}
    >
      <Paper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          minWidth: isOpen ? '300px' : 'unset',
          width: isOpen ? '300px' : '58px',
          height: `calc(100% - ${collapseActionButtonHeight})`,
          backgroundColor: theme =>
            theme.palette.appWhite.sideBarMenuContainerBgColor,
          borderRadius: '0',
          boxShadow: 'none',
        }}
      >
        <Paper
          sx={{
            bgcolor: 'background.paper',
            mt: 1,
            boxShadow: 'none',
            overflowY: 'auto',
            borderRadius: '0',
            marginTop: 0,
            overflowX: 'hidden',
          }}
          component="nav"
          aria-label="sidebar-menu folders"
        >
          <MenuList
            sx={{
              boxShadow: 'none',
              paddingTop: '0',
              paddingBottom: '0',
              ...(!isOpen && {
                overflowX: 'hidden',
              }),
            }}
          >
            {routes?.map(
              route =>
                !route.notVisibleInMenu && (
                  <SidebarMenuItem
                    key={route.title}
                    menuItem={route}
                    isMenuOpen={isOpen}
                  />
                )
            )}
          </MenuList>
        </Paper>
      </Paper>

      <MenuStateButton
        onClick={handleMenuState}
        isOpen={isOpen}
      ></MenuStateButton>
    </Paper>
  );
};

export default SidebarMenu;
